// 引入axios方法
import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
import {
  fun_CheckLockBrand,
  fun_ECCAInit,
  fun_GetExpirationDate,
  fun_GetLockNumber,
  fun_GetOrgId,
  fun_IsIe
} from "../../../utils/commonLock";
// 引入转译方法
import { fun_DownloadFile } from "@/utils/validate";
import { Message } from "element-ui";
// 引入加密方法
import "../../../utils/security.js";
export default {
  /**
   * 组件默认导出属性
   * @author 滕威
   */
  // 初始化数据
  data() {
    return {
      // 切换的状态
      activeName: "1",
      // 登录按钮loading
      loading: false,
      // ca驱动下来路径
      url: null,
      // 表单对象
      request: {
        exponent: null, // 加密exponent参数
        modulus: null, // 加密modulus参数
        title: null, // 验证码
        t: null, // 随机数
        flag: "4", // 4-监管登录
        username: null,  // 用户名
        password: null, // 密码
        wzbh: "201311080946010001", // 网站编号
      },
      form: {
        username: null, // 用户名
        password: null, // 密码
        title: null // 验证码
      },
      // 验证表单
      rules: {
        // 验证码
        title: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ]
      },
      // 图片路径对象
      codeImgSrc: null,
      // 全局加载
      fullLoading: null,
      // 锁品牌
      lockBrand: null,
      // ca校验数据
      retEncodedString: null,
      // 占位符
      userPlaceholder: "请输入您的用户名", // 用户名

    };
  },
  components: {
  },
  // 模板编译完成
  mounted() {
    // 获取加密
    this.fun_GetRSAKey();
    // 调用验证码方法
    this.fun_GetCode();
  },
  // 自定义事件
  methods: {
    /**
     * 获取验证码接口
     * @author 滕威
     */
    fun_GetCode() {
      // 获取随机数
      this.request.t = new Date().getTime();
      // 获取验证码
      this.codeImgSrc = `/brs-server/mime?t=${this.request.t}`;
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 获取参数接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取exponent
          this.request.exponent = data.exponent;
          // 获取modulus
          this.request.modulus = data.modulus;
        }
      });
    },
    /**
     * 登录方法
     */
    fun_Login() {
      // 关闭加载框
      this.fullLoading.close();
      // 加载框
      this.fun_Loading("正在进行登录，请耐心等待...");
      // 获取加密key
      this.key = window.RSAUtils.getKeyPair(this.request.exponent, "", this.request.modulus);
      // 遍历加密用户名、密码、验证码
      for (let e in this.form) {
        // 不为空
        if (this.form[e]) {
          // 加密
          this.request[e] = window.RSAUtils.encryptedString(this.key, this.form[e]);
        }
      }
      // 调用登录接口
      fun_PostAction("/userLogin/login", { ...this.request }).then(res => {
        // 关闭加载框
        this.fullLoading.close();
        const { result, data } = res.data;
        // 回调
        if (result) {
          // 登录成功添加token到vuex
          this.$store.commit("SET_TOKEN", data.token);
          this.$store.commit("SET_USERINFO", data.realName);
          this.$store.commit("SET_LOGINTYPE", data.loginType);
          this.$store.commit("SET_USERTYPE", data.userType);
          this.$store.commit("SET_USERFLAG", data.userFlag);
          this.$store.commit("SET_PROJECT", "brs");
          // 跳往首页
          this.$router.push({
            path: "/staffWorkbench"
          });
        } else {
          // 登录失败给出提示
          this.$message.error(res.data.msg);
          // 刷新验证码
          this.fun_GetCode();
          // 关闭loading状态
          this.loading = false;
          // 清空验证码输入框
          this.form.title = null;
        }
        // 加载框取消
        this.fullLoading.close();
      }).catch(err => {
        // 关闭加载狂
        this.fullLoading.close();
      });
    },
    /**
     * 工作人员登录
     */
    fun_RegistryLogin() {
      // 验证标识
      var flag = true;
      // 校验
      this.$refs.ruleForm.validate(valid => {
        // 校验通过
        if (!valid) {
          // 验证失败
          flag = false;
        }
      });
      // 验证失败
      if (!flag) {
        // 验证失败
        this.$message.error("请按提示修改！");
        return;
      }
      // 加载框
      this.fun_Loading("正在进行数字证书效验，请耐心等待...");
      // ca验证
      if (!this.fun_CheckCa()) {
        // 关闭加载框
        this.fullLoading.close();
        return;
      }
      // 校验
      this.fun_SecurityLoginByCA();
    },
    /**
     * 验证ca锁
     * @author zhouzhou
     */
    fun_CheckCa() {
      // 初始化
      fun_IsIe();
      // 获取锁品牌
      this.lockBrand = fun_CheckLockBrand();
      // 获取为空
      if (!this.lockBrand) {
        return;
      }
      // 判断是否指定品牌,信达汇格或中金ca
      if (this.lockBrand === this.$constant.CA_LOCKBRAND_XDHG || this.lockBrand === this.$constant.CA_LOCKBRAND_ZJCA) {
        // ca验证
        return true;
      } else {
        // 提示信息
        Message.error("电子锁信息读取失败，请确认是否插入CA证书！", "提示", { type: "warning" });
        return false;
      }
    },
    /**
     * ca登录验证
     * @author zhouzhou
     */
    fun_SecurityLoginByCA(){
      // 获取序列号
      var serialNumberHex = fun_GetLockNumber();
      // 证书到期日
      var expirationDate = fun_GetExpirationDate();
      // 参数
      var params = {"certSN": serialNumberHex, "expirationDate": expirationDate};
      // 判断是否为信达汇格
      if (this.lockBrand === this.$constant.CA_LOCKBRAND_XDHG) {
        // 调用接口验证
        fun_PostAction("/userLogin/xdhgCaVerify", params).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 关闭加载框
          this.fullLoading.close();
          // 成功
          if (result) {
            // 校验数据
            this.request.username = data.retEncodedString;
            // 执行回调
            this.fun_Login();
          } else {
            // 提示消息
            Message.error(msg, "提示", { type: "warning" });
          }
        }).catch(err => {
          // 关闭加载框
          this.fullLoading.close();
          console.log(err);
        })
      } else {
        // 调用接口验证
        fun_PostAction("/userLogin/zjCaVerify", params).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 关闭加载框
          this.fullLoading.close();
          // 成功
          if (result) {
            // 校验数据
            this.request.username = data.retEncodedString;
            // 执行回调
            this.fun_Login();
          } else {
            // 提示消息
            Message.error(msg, "提示", { type: "warning" });
          }
        }).catch(err => {
          // 关闭加载框
          this.fullLoading.close();
          console.log(err);
        })
      }
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading(msg) {
      this.fullLoading = this.$loading({
        lock: true,
        text: msg,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * tab切换方法
     */
    fun_GetHandleClick(tab){
      this.activeName = tab.name;
      // 判断是密码
      if(tab.name === "2"){
        // 切换时清空form表单
        for (let i in this.form) {
          // 清空
          this.form[i] = null;
        }
        this.$nextTick(() => {
          // 清除表单验证和数据
          if (this.$refs.form) this.$refs.form.clearValidate();
        })
      }
    },
    /*************************************用户密码登录**************************************/
    /**
     * 登录
     * @author 滕威
     */
    fun_SubmitForm() {
      // 监管登录
      this.fun_StaffLogin();
    },
    /**
     * 工作人员登录
     */
    fun_StaffLogin() {
      // 遮罩框加载
      this.fun_Loading();
      // 校验
      this.$refs.form.validate(valid => {
        // 校验通过
        if (valid) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(this.request.exponent, "", this.request.modulus);
          // 遍历加密用户名、密码、验证码
          for (let e in this.form) {
            this.request[e] = window.RSAUtils.encryptedString(this.key, this.form[e]);
          }
          // 发起请求
          fun_PostAction("/userLogin/bidSupervisionLogin", {
            ...this.request
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 操作成功
            if (result) {
              if(data.passwordMsg){
                // 错误提示
                this.$message.info(data.passwordMsg);
              }
              // 关闭遮罩
              this.fullLoading.close();
              // 谷歌key值
              this.secretKey = data.secretKey;
              // 用户编号
              this.user = data;
              // 登录成功添加token到vuex
              this.$store.commit("SET_TOKEN", this.user.token);
              this.$store.commit("SET_USERINFO", this.user.realName);
              this.$store.commit("SET_USERFLAG", this.user.userFlag);
              this.$store.commit("SET_USERTYPE", this.user.userType);
              this.$store.commit("SET_PROJECT", "brs");
              // 跳往首页
              this.$router.push({
                path: "/home"
              });
            } else {
              // 关闭遮罩
              this.fullLoading.close();
              // 错误提示
              this.$message.error(msg);
            }
          });
        } else {
          // 关闭遮罩
          this.fullLoading.close();
        }
      });
    },

  }
};
